import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { SvgLoading, HelmetWrapper, TYPES } from 'sarsaparilla';

import DivisionDetail from '../components/DivisionDetail';
import * as pActions from '../actions/permit';

const propTypes = {
  match: TYPES.MATCH,
  dispatch: PropTypes.func,
  permit: PropTypes.shape({
    divisions: PropTypes.object,
    id: PropTypes.string,
    name: PropTypes.string,
    recareas: PropTypes.arrayOf(PropTypes.string)
  }),
  permitDate: PropTypes.string,
  permitType: PropTypes.string,
  recarea: PropTypes.arrayOf(PropTypes.object)
};

const defaultProps = {
  permit: {
    divisions: [],
    id: '',
    name: ''
  }
};

export class DivisionDetailPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      permitId: props.match.params.permitId
    };
  }

  componentDidMount() {
    this.props.dispatch(pActions.fetchPermit(this.state.permitId))
      .then(() => {
        // fetch recarea for breadcrumbs
        const recId = this.props.permit?.recareas?.[0] ?? 0;
        this.props.dispatch(pActions.fetchRecarea(recId));
      });
  }

  render() {
    if (!this.props.permit || (this.state.permitId !== this.props.permit.id) || !(this.props.permit.divisions && Object.keys(this.props.permit.divisions).includes(this.props.match.params.divisionId))) {
      return (
        <div className="permit-loading-wrapper">
          <SvgLoading />
        </div>
      );
    }

    const division = this.props.permit.divisions[this.props.match.params.divisionId];

    return (
      <div className="inyonwhitney">
        <HelmetWrapper title={division.name} />
        <DivisionDetail
          division={division}
          permitDate={this.props.permitDate}
          permitId={this.props.permit.id}
          permitName={this.props.permit.name}
          permitType={this.props.permitType}
          recarea={this.props.recarea} />
      </div>
    );
  }
}

DivisionDetailPage.propTypes = propTypes;
DivisionDetailPage.defaultProps = defaultProps;

export default connect((state) => {
  return {
    error: state.inyonwhitney.permit.error,
    permit: state.inyonwhitney.permit.result,
    permitDate: state.inyonwhitney.permitDate,
    permitType: state.inyonwhitney.permitType,
    recarea: state.inyonwhitney.permit.recarea
  };
})(DivisionDetailPage);
